import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
/* API ENDPOINTS */
const { logout } = importer('APIs/users', null)
//
const { okta } = importer('APIs/auth', null)
const { logout: oktaLogout } = okta
/* ACTIONS */
const AuthCustomActions = importer('Stores/AuthCustom/Actions')
/* STATE */
const { GetToken } = importer('Stores/AuthCustom/Select', null)
export default function * main () {
  try {
    const token = yield select(GetToken)
    yield put(AuthCustomActions.logoutLoading())
    const res = yield logout(token)
    yield sessionLogout()
    yield put(AuthCustomActions.logoutSuccess(res))
  } catch (error) {
    yield sessionLogout()
    yield put(AuthCustomActions.logoutSuccess(error))
  }
}

function * sessionLogout () {
  try {
    yield oktaLogout()
  } catch (_) {}
}
